jQuery(document).foundation();

jQuery( document ).ready(function($) {




    // /* Pass the embed mode option here */
    // const viewerConfig = {
    //     embedMode: "LIGHT_BOX"
    // };
    
    // function previewFile()
    // {
    //     /* Initialize the AdobeDC View object */
    //     var adobeDCView = new AdobeDC.View({
    //         /* Pass your registered client id */
    //         // clientId: "78406cd3e26149cc8e38738d5e64bcdd"
    //         clientId: "23b8d4229ae04673b44eece942c0ee79"
            
    //     });
    
    //     /* Invoke the file preview API on Adobe DC View object */
    //     adobeDCView.previewFile({
    //         /* Pass information on how to access the file */
    //         content: {
    //             /* Location of file where it is hosted */
    //             location: {
    //                 url: "https://partner.internationalmedicalcorps.org/wp-content/uploads/2020/12/WHO-Psychological-First-Aid-for-Field-Workers-Amended.pdf",
    //                 /*
    //                 If the file URL requires some additional headers, then it can be passed as follows:-
    //                 header: [
    //                     {
    //                         key: "<HEADER_KEY>",
    //                         value: "<HEADER_VALUE>",
    //                     }
    //                 ]
    //                 */
    //             },
    //         },
    //         /* Pass meta data of file */
    //         metaData: {
    //             /* file name */
    //             fileName: "WHO-Psychological-First-Aid-for-Field-Workers-Amended.pdf"
    //         }
    //     }, viewerConfig);
    // };
    
    
    // $( ".pdf-ref" ).on( "click", previewFile );


    
if ($('body').hasClass('page-leaderboard')) {
    var submission_dates = JSON.parse(site.theme_path);
    var ajaxStartDate = '';
    var ajaxEndDate = '';

    var urlParams = new URLSearchParams(window.location.search);
    var queryVar = urlParams.get('event');


    //var queryVar = '';
   
    
    if (document.getElementById('litepicker')){

    var picker = new Litepicker({ 
        element: document.getElementById('litepicker'),
        highlightedDays: submission_dates,
        dropdowns: {
            minYear: new Date().getFullYear() - 150,
            maxYear: new Date().getFullYear() + 100,
            months: true,
            years: true
        },
       // format: 'YYYY-MM-DD',
        onSelect: function(date1) {
            date1 = new Date(date1).getFullYear()+'-'+("0"+(new Date(date1).getMonth()+1)).slice(-2)+'-'+("0"+new Date(date1).getDate()).slice(-2); 
            ajaxStartDate = date1;
            ajaxEndDate = date1;  
            console.log(date1);
            update();
        }
    });
}


    function update() {

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: "html", // add data type
            data: { 
                action : 'get_ajax_posts',
                'ajaxStartDate': ajaxStartDate,
                'ajaxEndDate': ajaxEndDate,
                'queryVar': queryVar 
            },
            success: function( response ) {
                //console.log( response );
                $( '.submissions' ).html( response ); 
            }
        }).then(function() {           // on completion, restart
           setTimeout(update, 5000);  // function refers to itself
        });
    };                              
    update();// automatically invoke for first run

}


    var startTime2, interval, loggedTime;

    function start(){
        startTime2 = Date.now();
        interval = setInterval(function(){
            updateDisplay(Date.now() - startTime2);
        });
    }
    
    function stop(){
        clearInterval(interval);
    }
    
    function updateDisplay(currentTime){
        // do your stuff
        $('#time').text(`${Math.floor(currentTime / 1000)}`);
        loggedTime = `${Math.floor(currentTime)}`;
    }

    start();


    if(typeof Marionette !== 'undefined') {
        var mySubmitController = Marionette.Object.extend( {
            initialize: function() {
                // init listener
                this.listenTo( Backbone.Radio.channel( 'forms' ), 'view:show', this.initAction);
                // field change listener
                this.listenTo( Backbone.Radio.channel( 'fields' ), 'change:modelValue', this.valueChanged);
                // submit listener
                this.listenTo( Backbone.Radio.channel( 'forms' ), 'submit:response', this.actionSubmit );

                // Listen for part change events.
                this.listenTo( Backbone.Radio.channel( 'nfMP' ), 'change:part', this.changePart, this );

                this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.doCustomStuff );


               // Backbone.Radio.channel( 'form-' + formID ).reply( 'maybe:submit', this.beforeSubmit, this, formID );

               // this.listenTo( Backbone.Radio.channel( 'form' ).reply('maybe:submit', this.beforeSubmit, this, form ));

                this.listenTo( nfRadio.channel( 'forms' ), 'before:submit', this.beforeSubmit);

               // this.listenTo( Backbone.Radio.channel( 'pikaday' ), 'init', this.modifyDatepicker );	


               /// nfRadio.channel("forms").on("before:submit", function(e) {

                       // On the Form Submission's field validaiton...
        var submitChannel = Backbone.Radio.channel( 'submit' );
        this.listenTo( submitChannel, 'validate:field', this.validateRequired );

        // var fieldsChannel = Backbone.Radio.channel( 'fields' );
        // this.listenTo( fieldsChannel, 'change:modelValue', this.validateRequired );





            },

            validate: function( model ) {

                // ...
        




            },

            validateRequired: function( model ) {

                // Check the field key.
                if( 'select_team' != model.get( 'key' ) ) return;

                console.log(model.toJSON());

                
                // Get the field value.
                // var fieldValue = model.get( 'value' );
                // var modelID       = model.get( 'id' );
                // alert(modelID);

                // If validation fails...
                var fieldValue = model.get( 'value' );
                var modelID       = model.get( 'id' );
                var errorID       = 'required-error';
                var errorMessage  = 'Please Select a Team';
                var fieldsChannel = Backbone.Radio.channel( 'fields' );
                
                if(fieldValue == "") {
                    // Add Error
                    fieldsChannel.request( 'add:error', modelID, errorID, errorMessage );
                }



            },

            beforeSubmit: function( formID ) {

                // var formModel = nfRadio.channel( 'app' ).request( 'get:form', formID );
        
                // if( formModel.getExtra( 'my_restart_flag' ) ) return true;
        
                // this.otherProcessing( formModel );
        
                // // Halt form submission.
                // return false;
                console.log('before submitted');

                var fieldID = 25;
                var newValue = '100000000';
                jQuery( '#nf-field-' + fieldID ).val( loggedTime ).trigger( 'change' );


         

                var eventNameQuerySource = jQuery( '#nf-field-' + '41' ).val();
                if (eventNameQuerySource) {
                    eventNameQuerySource = eventNameQuerySource.replace(/\s+/g, '-').toLowerCase();
                    jQuery( '#nf-field-' + '42' ).val(eventNameQuerySource).trigger( 'change' );
                }
                
                //$('#nf-form-1-cont .submit-wrap input[type="button"]').click();
            },

            doCustomStuff: function( view ) {


                // $('.nf-form-cont').find("nf-field").contents().unwrap();
                // $('.nf-form-cont').find("nf-fields-wrap").contents().unwrap();
                // $('.nf-form-cont').find("nf-section").contents().unwrap();
                // $('.nf-form-cont').find("nf-errors").contents().unwrap();

                if ($('body').hasClass('page-thank-first-responder')) {


                $( ".firstname-container" ).wrap( "<div class='firstlast small-12 medium-6 cell'></div>" );
                $( ".lastname-container" ).wrap( "<div class='firstlast small-12 medium-6 cell'></div>" );
                $( ".firstlast" ).wrapAll( "<div class='grid-x grid-margin-x firstlast-wrap' />");
                $( ".firstlast-wrap" ).wrapAll( "<div class='firstlast-container' />");


                $( ".checkbox-container" ).wrap( "<div class='checkbox-email small-12 medium-5 cell'></div>" );
                $( ".email-container" ).wrap( "<div class='checkbox-email small-12 medium-auto cell'></div>" );
                $( ".checkbox-email" ).wrapAll( "<div class='grid-x grid-margin-x checkbox-email-wrap' />");
                $( ".checkbox-email-wrap" ).wrapAll( "<div class='checkbox-email-container' />");

                }

               //  $( "#nf-field-130-container" ).insertBefore( "<div class='grid-x'><div class='small-12 medium-6 cell'>" );
                // $( "#nf-field-130-container" ).insertAfter( "</div>" );

                // $( "#nf-field-131-container" ).insertBefore( "<div class='small-12 medium-6 cell'>" );
                // $( "#nf-field-131-container" ).insertAfter( "</div></div>" );

                
                
                var formModel = view.model; // formModel will be a Backbone model with all of our form data.

                var fieldModel = formModel.get( 'fields' ).findWhere( { key: 'quiz_time' } );

                var fieldModel2 = formModel.get( 'fields' ).findWhere( { key: 'checkbox_1607753315165' } );
                
                $(".nf-mp-body").css('opacity', '1');


                //$('.select_team-container select').prepend('<option hidden disabled selected value>Select Team</option>');
                $(".select_team-container select option[value='']").attr( { disabled:true, hidden:true } );
                

              
          
                /*
                 * We can also update or modify fields now.
               * 
               * If we wanted to change a field value, for instance, and we knew the field key we wanted to target, we'd do something like:
               * var fieldModel = formModel.get( 'fields' ).findWhere( { key: 'your_key' } )
               *
               * If you want to get a field by ID, you'd use:
               * var fieldModel = formModel.get( 'fields' ).get( '99' );
               * 
               * Now that we have our field model, we can modify any of its settings.
               *
               * fieldModel.set( 'label', 'New Field Label' );
               * fieldModel.set( 'value', 'New Value' );
               * fieldModel.trigger( 'reRender' ); // Tells the field to re-draw itself.
               * 
               *
               * You can do this with regular jQuery stuff if you know the ID # of your field.
               *
               * jQuery( '#nf-field-99' ).val( 'New Text!' ).change();
               * 
               * If you change something using a jQuery .val() method, you'll need to call a .change() on the element as well.
               *
                 */
            },
            
    
            // init action
            initAction: function() {
                console.log("init");
            },
    
            // input update action
            valueChanged: function(model) {
                
                //$(".nf-next").click();
                var fieldValue = model.get( 'value' );
                var fieldType = model.get( 'type' );
                var fieldID = model.get( 'id' );
                var fieldKey = model.get( 'key' );
                var formID = model.get( 'formID' );


////////////////////////////////////////////////////////////// LIGHTNING QUIZ PENALTY TIMER

                if (formID == "1") {
                    if (fieldType == 'listradio') {
                    
                    var containerID = "nf-field-"+fieldID+"-container";

                    console.log(model.toJSON());

                    var selectedID = $(`#${containerID} .nf-checked`).attr('id');
                    var slicedID = selectedID.slice(selectedID.length - 1);
                    
                    //console.log(selectedID.slice(selectedID.length - 1)); //Outputs: 1

                    var getOptions = model.get( 'options' );
                    var calcValue = getOptions[slicedID].calc;
                    console.log(calcValue);
                    var fieldClass = model.get( 'element_class' );

                    if (calcValue == 1) {

                        
        
                            $(`#${containerID}`).removeClass('incorrect');    
                            $(`#${containerID}`).addClass('correct');
                            
                            Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'custom-field-error' );


                    } else {

                            Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'custom-field-error', 'Wrong Answer!' );
                            $(`#${containerID}`).removeClass('correct');
                            $(`#${containerID}`).addClass('incorrect');

                            setTimeout(function(){
                                $('#wrong-answer').foundation('open');
            
                            }, 150);
                            

                            const maxTime = 1000 * 4;

                            const out = document.querySelector("#out");
                            function msToTime(duration) {
                            let milliseconds = parseInt((duration % 1000));
                            let seconds = Math.floor((duration / 1000) % 60);
                            let minutes = Math.floor((duration / (1000 * 60)) % 60);
                            // let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

                            // hours = hours.toString().padStart(2, '0');
                            minutes = minutes.toString().padStart(2, '0');
                            seconds = seconds.toString().padStart(2, '0');
                            milliseconds = milliseconds.toString().padStart(3, '0');

                            return seconds;
                            }

                            let timer;
                            function countDown() {
                                const diff = Date.now() - startTime;
                                const remaining = Math.max(maxTime - diff, 0);
                                if (remaining > 0) {
                                    out.textContent = msToTime(remaining);
                                    timer = window.setTimeout(countDown, 20);
                                } else {
                                    out.textContent = '';
                                    window.localStorage.removeItem('timer');
                                    $("#wrong-answer").foundation("close");
                                    $("#nf-form-1-cont form").css('opacity','1');
                                    $("#nf-form-1-cont form :input").prop("disabled", false);
                                }
                            }

                            const storageTime = window.localStorage.getItem('timer');
                            let startTime = storageTime ? +storageTime : null;

                            if (startTime) countDown();

                            if (timer) window.clearTimeout(timer);
                            startTime = Date.now();
                            countDown();
                            window.localStorage.setItem('timer', startTime);
                        
                    }
                }
            } 

///////////////////////////////////////////

            },
    
            // submit action
            actionSubmit: function( response ) {
                // handled via php
                //console.log("submit");
               // console.log(response);
            //     console.log(response);
            //    console.log(response.errors);
                console.log(response.errors.length);
               if (response.errors.length == 0) {
                $('.nf-response-msg').addClass('content-box');
                stop();
              }

              

                
                
            },

        });
    
        // initialise listening controller for ninja form
        new mySubmitController();
    }








 
});    


